import { Stack, Typography } from "@mui/material";
import { Authorizer } from "@navigations/Authorizer";
import type { Control } from "react-hook-form";
import type { IModalActionForm, IModalActionResolver } from "../../logics/types";
import { ModalActionFormAppointmentReminder } from "../AppointmentReminder";
import { NextAction } from "./nextAction";
import { Pinned } from "./pinned";
import { SendCalendarEvent } from "./sendCalendarEvent";

export interface IActionOptionsProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
}

export const ActionOptions = ({ control }: IActionOptionsProps) => {
  return (
    <Stack
      sx={{
        gap: 1,
      }}
    >
      <Typography variant="subtitle2SemiBold" color="primary" sx={{ marginBottom: 1 }}>
        Options suite à cette action
      </Typography>
      <Authorizer
        requiredPermissions={["action.appointmentReminder"]}
        Authorized={ModalActionFormAppointmentReminder}
        AuthorizedProps={{ control: control }}
      />
      <Authorizer
        requiredPermissions={["action.nextAction.create"]}
        Authorized={NextAction}
        AuthorizedProps={{ control: control }}
      />
      <Pinned control={control} />
      <Authorizer
        requiredPermissions={["ics.action.send"]}
        Authorized={SendCalendarEvent}
        AuthorizedProps={{ control: control }}
      />
    </Stack>
  );
};
